import CoreModel from "../../service/CoreModel";
import Service from "./Service";
import moment from "moment";

export default class ViewModel extends CoreModel {
  constructor() {
    super();
    this.service = new Service();

    this.state = {
      fullData: [],
      data: [],
      pages: null,
      loading: true,
      currentPage: 1,
      pageSize: 15,
      successMessage: "",
      errorMessage: "",
      selecionado: {},
      showModal: false,
      center: {
        latitude: 0,
        longitude: 0,
      },
      orig: {
        latitude: 0,
        longitude: 0,
      },
      dest: {
        latitude: 0,
        longitude: 0,
      },
      dataFinal: moment(),
      dataInicial: moment().add('days', -60).startOf("month"),
    };
  }


  closeDetails = () => {
    this.setState({ showModal: false, selecionado: {} });
    this.fetchData();
  }
  fetchData2 = async () => {
    this.setState({ loading: true });
    try {
      const fullData = await this.service.listar(
        this.state.dataInicial,
        this.state.dataFinal
      );
      this.setState({
        showModal: false,
        fullData,
        data: fullData.slice(0, this.state.pageSize),
        pages: Math.ceil(fullData.length / this.state.pageSize),
        loading: false,
      });
    } catch (error) {
      console.log("Erro ao listar:", error);
      this.setState({ error, loading: false });
    }
  };

  onPageChange = (pageIndex) => {
    this.setState({
      currentPage: pageIndex,
    });
    this.fetchData();
  };

  fetchData = async () => {
    this.setState({ loading: true });
    try {
      const result = await this.service.getTipo(
        'corridas',
        "",
        [{ id: "-t12_dthr_corridas" }],
        this.state.currentPage,
        this.state.pageSize,
        [{ id: "ztatus1", value: "8"}, {id: "t12_dthr_corridas", value: {"gt": this.state.dataInicial} }]
      );
      let fullData = result.result;
      let count = result.count;
      this.setState({
        showModal: false,
        fullData,
        data: fullData,
        pages: Math.ceil(count / this.state.pageSize),
        loading: false,
      });
    } catch (error) {
      console.log("Erro ao listar:", error);
      this.setState({ error, loading: false });
    }
  };

  escolhecorrida = (selecionado) => {
    this.setState({
      selecionado: selecionado,
      showModal: true,
      center: {
        latitude: selecionado.t12_lat,
        longitude: selecionado.t12_lon,
      },
      orig: {
        latitude: selecionado.t12_lat,
        longitude: selecionado.t12_lon,
      },
      dest: {
        latitude: selecionado.latitudedestino,
        longitude: selecionado.longitudedestino,
      },
    });
  };

  onPageChange2 = (pageIndex) => {
    const { fullData, pageSize } = this.state;
    const startRow = pageIndex * pageSize;
    const endRow = startRow + pageSize;
    this.setState({
      currentPage: pageIndex,
      data: fullData.slice(startRow, endRow),
    });
  };
}
